<template>
    <div class="flex flex-col gap-2">
        <DsUpload
            v-model:fileList="fileList"
            :dataTypes="[DocumentDataType.PDF]"
            :multiple="false"
            size="md"
        />
        <div class="flex gap-2">
            <DsButton
                size="md"
                variant="primary"
                @click="page = Math.max(1, page - 1)"
            >
                Prev
            </DsButton>
            <DsButton
                size="md"
                variant="primary"
                @click="page++"
            >
                Next
            </DsButton>
        </div>
        <div class="mt-4 h-[calc(100dvh*0.66)]">
            <PDFViewer
                v-if="fileList[0]"
                v-model:focusPage="page"
                :annotations
                :source="fileList[0].file"
            />
        </div>
    </div>
</template>

<script setup lang="ts">
import DsButton from '@/components/design-system/button/DsButton.vue';
import { DocumentDataType } from '@/components/design-system/upload/document-data-types';
import type { StagedDocument } from '@/components/design-system/upload/ds-upload.types';
import DsUpload from '@/components/design-system/upload/DsUpload.vue';
import PDFViewer from '@/components/shared/pdf/PDFViewer.vue';
import type { PDFAnnotationInput } from '@/shared/utils/pdf/pdf-annotations.types';
import { ref } from 'vue';

const annotations: PDFAnnotationInput[] = [
    {
        page: 1,
        boundingBox: [
            { x: 0.2764505, y: 0.12747253 },
            { x: 0.5227531, y: 0.12747253 },
            { x: 0.5227531, y: 0.14241758 },
            { x: 0.2764505, y: 0.14241758 },
        ],
        fill: '#ff008c', // pink annotation
        stroke: '#ff008c',
        opacity: 0.3,
        strokeWidth: 1,
    },
    {
        page: 2,
        boundingBox: [
            { x: 0.2, y: 0.3 },
            { x: 0.7, y: 0.3 },
            { x: 0.7, y: 0.4 },
            { x: 0.2, y: 0.4 },
        ],
        fill: '#ffd900', // yellow annotation
        stroke: '#ff008c', // pink border
        opacity: 0.5,
        strokeWidth: 1,
    },
];

const fileList = ref<StagedDocument[]>([]);
const page = ref(1);
</script>
